export default {
  default: () => import("D:/workFile/taro-trip/src/layouts/default.vue").then(m => m.default || m),
  footer: () => import("D:/workFile/taro-trip/src/layouts/footer.vue").then(m => m.default || m),
  header: () => import("D:/workFile/taro-trip/src/layouts/header.vue").then(m => m.default || m),
  login: () => import("D:/workFile/taro-trip/src/layouts/login.vue").then(m => m.default || m),
  register: () => import("D:/workFile/taro-trip/src/layouts/register.vue").then(m => m.default || m)
}